import { useState, useEffect } from 'react';
import { BXPTreatmentsTable } from 'components/tables/BXPTreatmentsTable';
import {
  fetchBXPTreatments,
  BXPTreatment
} from 'services/hvaservicecampaign.service';

const BXPTreatmentList: React.FC = () => {
  const [treatments, setTreatments] = useState<BXPTreatment[]>([]);
  const loadTreatments = async (): Promise<void> => {
    try {
      const fetchedTreatments = await fetchBXPTreatments();
      setTreatments(fetchedTreatments);
    } catch (error) {
      console.error('Error loading treatments:', error);
    }
  };

  useEffect(() => {
    loadTreatments();
  }, []);

  return (
    <div>
      <div className="mb-2">
        <BXPTreatmentsTable
          treatments={treatments}
          onTreatmentsChange={loadTreatments}
        />
      </div>
    </div>
  );
};

export default BXPTreatmentList;
